import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import '../../../scss/pages/_menu-list.scss';
import Select from "react-select";
import Item from './item.component';
import Category from './category.component';
import EditItem from './EditItem';
import EditCategory from './EditCategory';
import { useHistory } from 'react-router-dom';


const AddMenu = ({ handleDetailsSidebar, details, component, title, categoryid }) => {
    
   

    return (
        <div className={details ? "orderDetailsActive" : "orderDetails"}>
            <div className="top-portion d-flex justify-content-start align-items-center">
                <span onClick={() => handleDetailsSidebar("close")} style={{ cursor: 'pointer' }}><i className="bi bi-arrow-left ms-4 me-3"></i></span>
                <span>{title && title}</span>
            </div>

            {component === 'item' &&
                <Item />
            }

            {
                component === "category" &&
                <Category
                    handleDetailsSidebar={() => handleDetailsSidebar("close")}
                />
            }

            {
                component === "editItem" &&
                <EditItem />
            }

            {
                component === "editCategory" &&
                <EditCategory categoryid={categoryid} handleDetailsSidebar={() => handleDetailsSidebar("close")} />
            }

        </div>
        // </form>

    );
};

export default AddMenu;